import axios from 'axios';
import { protectedAxiosInstance } from 'helpers/api-calls';
import { createApiDateFormat } from '../date-time';

import { IN_APP_NOTIFICATIONS_PER_PAGE } from 'constants/index';
import { getLocationCode, getLocaleCookie } from '../cookies';

const inAppNotificationsApiUrl = '/api/customer/user_role/notifications';

/**
 * Get in app notifications
 * @param { Int } per_page - the amount of notifications to be returned
 * @param { Int } page - which page of notifications needs to be returned
 *
 * @return { Object } this contains the stats for the notifications (total count, current page, etc)
 *                    and then an array of the notifications
 */
export const LoadFirstPageInAppNotifications = () => {
  const location_id = getLocationCode('location_id');
  const locale = getLocaleCookie();
  return protectedAxiosInstance.get(
    inAppNotificationsApiUrl,
    {
      params: {
        page: 1,
        per_page: IN_APP_NOTIFICATIONS_PER_PAGE,
        order: 'created_at_desc',
        location_id,
        locale,
        'response[except]': 'sender[recent_user_privilege],recipient[recent_user_privilege]',
        'response[nested]': '2'
      },
    }
  );
};

/**
 * Get more in-app notifications on specified page
 * @param { Int } page - which page of notifications needs to be returned
 *
 * @return { Object } this contains the stats for the notifications (total count, current page, etc)
 *                    and then an array of the notifications
 */
export const LoadMoreInAppNotifications = (pageNum) => {
  const location_id = getLocationCode('location_id');
  const locale = getLocaleCookie();
  return protectedAxiosInstance.get(
    inAppNotificationsApiUrl,
    {
      params: {
        page: pageNum,
        per_page: IN_APP_NOTIFICATIONS_PER_PAGE,
        order: 'created_at_desc',
        location_id,
        locale,
        'response[except]': 'sender[recent_user_privilege],recipient[recent_user_privilege]',
        'response[nested]': '2'
      },
    }
  );
};

export const LoadSingleInAppNotification = (id) =>
  protectedAxiosInstance
    .request({
      url: inAppNotificationsApiUrl + `/${id}`,
      method: 'GET',
      params: {
        'response[except]': 'sender[recent_user_privilege],recipient[recent_user_privilege]',
        'response[nested]': '2'
      },
    })
    .then((response) => response);

/**
 * Read a Notification
 * @param { String | Int } id - id of the in-app Notification
 */
export const ReadInAppNotification = (id) => {
  const payload = {
    "notification": {
      "viewed": true,
    }
  };
  return protectedAxiosInstance.request({
    url: inAppNotificationsApiUrl + `/${id}`,
    method: 'PUT',
    data: payload
  });
};

/**
 * Delete an in-app Notification
 * @param { String | Int } id - id of the in-app Notification
 */
export const DeleteInAppNotification = (id) => {
  return protectedAxiosInstance.request({
    url: inAppNotificationsApiUrl + `/${id}`,
    method: 'DELETE',
  });
};

/**
 * Delete all in-app Notifications
 * @param { String | Int } id - id of the in-app Notification
 * * @param { Boolean } isDeleteAll - delete all or only viewed notifications
 */
export const DeleteAllInAppNotifications = (id, isDeleteAll) => {
  const addParams = isDeleteAll ? undefined : { 'viewed': true };

  return protectedAxiosInstance.request({
    url: inAppNotificationsApiUrl + `/destroy_all`,
    method: 'DELETE',
    params: addParams,
  });
};

